import IArborProviderConfig from "../../../models/misconfig/arbor/ArborProviderConfig";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import IConfigJson from "../../../models/misconfig/ConfigJson";
import BiometricFilterView from "../biometric-filter-view";
import { GUID } from "../../../app/common/helper/Guid";
import { useArborApplications } from "../../../hooks/useArborApplications";

interface IArborProviderConfigViewProps extends IConfigJson {
    arborApplicationID?: GUID | null;
}

export default function ArborProviderConfigView(props: IArborProviderConfigViewProps) {
    const [ArborConfig, setArborConfig] = useState<IArborProviderConfig | null>(null);
    const { data: applications = [] } = useArborApplications();
    const selectedApplication = applications.find((application) => application.applicationID === props.arborApplicationID);

    useEffect(() => {
        if (props.configJson) {
            const configObj: IArborProviderConfig = JSON.parse(props.configJson);
            setArborConfig(configObj);
        }
    }, [props.configJson]);

    return (              
        <React.Fragment>
             <Row>
                <Col md={4} className="pb-2"><b>School URL</b></Col>
                <Col md={8}>{ArborConfig?.ApiCredentials.EstablishmentUrl}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2"><b>Arbor Application</b></Col>
                <Col md={8}>{selectedApplication?.applicationName ?? 'Migration required'}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2"><b>Query page size</b></Col>
                <Col md={8}>{ArborConfig?.GraphQLPageSize}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2"><b>Photo page size</b></Col>
                <Col md={8}>{ArborConfig?.GraphQLPhotoPageSize}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2"><b>Retrieve account IDs?</b></Col>
                <Col md={8}>{ArborConfig?.RetrieveAccountIDs ?? false ? 'Yes' : 'No'}</Col>
            </Row>            
            <Row>
                <Col md={4} className="pb-2"><b>Retrieve transitional FSMs?</b></Col>
                <Col md={8}>{ArborConfig?.RetrieveTransitionalFSM ?? false ? 'Yes' : 'No'}</Col>
            </Row>
            <BiometricFilterView filter={ArborConfig?.BiometricConsents}/>            
        </React.Fragment>
    );
}